module.exports = __webpack_public_path__ + "img/04.ea16a700.jpg";